<template>
  <div>
    <Layout>
      <div v-for=" (item,index) in mobileAboutNews" :key="index" class="container">
        <div @click="toNewsDetails(item.id)" class="content">
            <img :src="item.img" />
            <div v-html="isChinese ? item.chTitle : item.enTitle" :class="isChinese ? '' : 'mecity' " class="title"></div>
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/public/layout'
import config from '@/config'
export default {
  data() {
    return {
      mobileAboutNews: config.pageData.mobileAboutNews
    };
  },
  methods: {
    toNewsDetails(id) {
      this.$router.push({ path: 'detail', query: { id } })
    }
  },
  computed: {
    isChinese() {
      const language = this.$i18n.locale;
      if (language === 'cn') {
        return true;
      } else {
        return false;
      }
    }
  },
  components: {
    Layout
  },
  created() {

  }
}

</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "index";
</style>
